var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.game.thuuz)?_c('v-chip',{attrs:{"small":"","color":_vm.game.thuuz ? _vm.thuuzColor(_vm.game.thuuz) : 'primary'}},[_vm._v("\n    Hype: "+_vm._s(_vm.game.thuuz)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }